// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__juWOe","title":"styles_title__UPHwH system_titleXs__NdNAh","titleContainer":"styles_titleContainer__dVwwc"};